"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat = exports.CHAT_RULE_PREFIX = void 0;
exports.CHAT_RULE_PREFIX = 'chat';
var Chat;
(function (Chat) {
    Chat["Report"] = "chat:report";
    Chat["MessageTime"] = "chat:message-time";
    Chat["Moderate"] = "chat:moderate";
    Chat["Pin"] = "chat:pin";
    Chat["Block"] = "chat:block";
})(Chat || (exports.Chat = Chat = {}));
